import createReactComponent from '../createReactComponent';
export default createReactComponent('clock-hour-7', 'IconClockHour7', [
  ['path', { d: 'M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0', key: 'svg-0' }],
  ['path', { d: 'M12 12l-2 3', key: 'svg-1' }],
  ['path', { d: 'M12 7v5', key: 'svg-2' }],
]);
